@if (isLoggedInUser() && !isLayoutHidden) {
  <ng-container>
    <vertical-layout-1></vertical-layout-1>
  </ng-container>
  <button
    (click)="toggleSidebarOpen('themeOptionsPanelHelp')"
    mat-icon-button
    class="mat-elevation-z2 theme-options-button help-button"
  >
    <mat-icon>help_outline</mat-icon>
    <span>Help</span>
  </button>

  <div
    class="custom-helpdesk-sidebar theme-options-sidebar-help-desk"
    [class.open]="isHelpDeskOpen()"
  >
    <app-help-desk></app-help-desk>
  </div>

  @if (isHelpDeskOpen()) {
    <div
      class="custom-helpdesk-backdrop"
      (click)="toggleSidebarOpen('themeOptionsPanelHelp')"
    ></div>
  }

  <div
    class="custom-bulkinvoice-sidebar theme-options-sidebar-bulkInvoice-data"
    [class.open]="isBulkInvoicingWorkItemOpen()"
  >
    <app-bulk-invoicing-workitem></app-bulk-invoicing-workitem>
  </div>

  @if (isBulkInvoicingWorkItemOpen()) {
    <div
      class="custom-bulkinvoice-backdrop"
      (click)="toggleSidebarOpen('BulkInvoicingWorkItemPanel')"
    ></div>
  }

  <div
    class="custom-firmdirectory-sidebar theme-user-firm-directory-contact-detail"
    [class.open]="isFirmDirectoryContactDetailOpen()"
  >
    <app-user-firm-directory-contact-detail></app-user-firm-directory-contact-detail>
  </div>

  @if (isFirmDirectoryContactDetailOpen()) {
    <div
      class="custom-firmdirectory-backdrop"
      (click)="toggleSidebarOpen('firmDirectoryContactDetail')"
    ></div>
  }
} @else {
  <router-outlet></router-outlet>
}
